import React from 'react';
import useSiteMetadata from '../../hooks/useSiteMetadata';
import {
  ProductRatingType,
  Product,
  ProductMinMaxPriceType,
} from '../../types';
import { getUniqueProducts } from '../../utils/common';
import Pagination from '../Pagination';
import ProductCard from './ProductCard';

interface Props {
  products: Product[];
  isAnyFilterActive?: boolean;
  pageContext: {
    productsRating: ProductRatingType;
    productsMinMaxPrice: ProductMinMaxPriceType;
  };
}

const ListProducts: React.FC<Props> = ({
  products,
  isAnyFilterActive = false,
  pageContext,
}) => {
  const { siteSubject } = useSiteMetadata();
  const uniqueProducts = getUniqueProducts(products);
  const { productsRating, productsMinMaxPrice } = pageContext;
  const hasFilterResult = !!products.length;
  const productsList = uniqueProducts.map((product) => (
    <div key={product.data.name}>
      <ProductCard
        product={product}
        rating={productsRating[product.data.name] ?? 0}
        pricingFrom={productsMinMaxPrice[product.data.name]?.min ?? 0}
      />
    </div>
  ));

  return (
    <React.Fragment>
      <div className="pl-4">
        <h1 className="text-xl">{siteSubject}</h1>
        <p className="pb-3 text-xs">{`View & compare the top ${siteSubject}`}</p>
      </div>
      {isAnyFilterActive && !hasFilterResult ? (
        <div className="pl-4">
          <h1 className="text-xl text-center pb-3">No result</h1>
        </div>
      ) : null}
      <div className="grid grid-flow-row grid-cols-1 gap-8 lg:grid-cols-3 sm:grid-cols-2">
        {productsList}
      </div>
      {isAnyFilterActive ? null : (
        <div className="border-t border-gray-100 pt-7">
          <Pagination pageContext={pageContext} />
        </div>
      )}
    </React.Fragment>
  );
};

export default ListProducts;
